import {Injectable} from "@angular/core";
import {RutasWebServices} from "../../services/rutasWebServices";
import { tap, map } from "rxjs/operators";
import { HttpClient,HttpHeaders, HttpParams } from  '@angular/common/http';


@Injectable()
export class FormatoGenericoService{
  
  constructor(private _http:HttpClient){}


  getFormatoGenerico(IdFormatoGenerico:number, Estudio:number, IdFirma?:string){
    
    let params=$.param({IdFormatoGenerico:IdFormatoGenerico, Estudio: Estudio, IdFirma:IdFirma});
    let rutasWS = new RutasWebServices();

    return this._http.get(rutasWS.urlWebService("GetFormatoGenerico")+'?'+params).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
      )
  }

  GuardarFirma(IdFormatoGenerico:number, Modulo:string, CodigoRowModulo:number, Firma:string){
    
    let params=$.param({idFormatoGenerico:IdFormatoGenerico, modulo: Modulo, codigoRowModulo: CodigoRowModulo, firma: Firma});
    let rutasWS = new RutasWebServices();

    const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type':  'application/x-www-form-urlencoded'
			}),
			params: new HttpParams().set('idFormatoGenerico', IdFormatoGenerico+'')
									.set('modulo', Modulo+'') 
									.set('codigoRowModulo', CodigoRowModulo+'') 
									.set('firma', '145') 
    };
    
    return this._http.post(rutasWS.urlWebService("GuardarFirma"),params,httpOptions).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
      )
  }
  
}